import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DateTransform } from '@app/shared/utils/date.transform';

export function dateAfterValidator(compareTo: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!compareTo) {
      return null;
    }

    const value = new Date(control.value);
    const compareToDate = new Date(compareTo.value);

    if (DateTransform.isBefore(DateTransform.startOfDay(value), DateTransform.startOfDay(compareToDate))) {
      return { dateShouldBeAfter: true };
    }

    return null;
  };
}
